<template>
  <div class="cg-root">
    <div v-if="store.error" class="cg-error">{{ store.error }}</div>
    <template v-else>
      <WizardToolbar
        v-if="store.gommista"
        :store="store"
        :static-base-url="staticBaseUrl"
      />
      <div v-if="store.step === 'slot'">
        <SlotView :store="store" :api="api" />
      </div>
      <div v-else-if="store.step === 'form'">
        <FormPrenotazione :store="store" :api="api" />
      </div>
      <div v-else-if="store.step === 'landing'">
        <LandingPrenotazione />
      </div>
      <footer class="cg-footer">
        <a href="https://www.cambiogomme-online.it" target="_blank" rel="noopener noreferrer" class="cg-footer-link">powered by www.cambiogomme-online.it</a>
      </footer>
    </template>
  </div>
</template>

<script setup>
import WizardToolbar from './components/WizardToolbar.vue'
import SlotView from './components/SlotView.vue'
import FormPrenotazione from './components/FormPrenotazione.vue'
import LandingPrenotazione from './components/LandingPrenotazione.vue'

defineProps({
  store: { type: Object, required: true },
  api: { type: Object, required: true },
  /** Base URL per immagini statiche (logo gommista). Opzionale. */
  staticBaseUrl: { type: String, default: '' },
})
</script>

<style scoped>
.cg-root {
  font-family: system-ui, -apple-system, sans-serif;
  max-width: 640px;
  margin: 0 auto;
  padding: 0 1rem;
  box-sizing: border-box;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 1px 3px rgb(0 0 0 / 0.08);
}
.cg-error {
  padding: 1rem;
  background: #fef2f2;
  color: #b91c1c;
  border-radius: 6px;
  font-size: 0.875rem;
}

.cg-footer {
  margin-top: 1rem;
  padding-top: 0.75rem;
  border-top: 1px solid #e5e7eb;
  text-align: center;
}

.cg-footer-link {
  font-size: 0.75rem;
  color: #6b7280;
  text-decoration: none;
}

.cg-footer-link:hover {
  color: #ca8a04;
  text-decoration: underline;
}
</style>
